import axios from 'axios'
import {CookiesService} from './Cookie.service'
import {AuthApi} from './AuthApi.service'
/**
 * Instância axios do módulo Trilha do Guru (academy-service, FastAPI).
 *
 * baseURL = VITE_ACADEMY_URL — deve conter o prefixo completo da API.
 * Valor local: http://localhost:8085/api/academy/v1
 *
 * Mesmo padrão do axiosInstanceLevantamento: em dev o academy-service aceita
 * bypass (DEV_AUTH_KEY); em produção valida o JWT do core (JWT_SECRET
 * compartilhado). Anexamos o Bearer do cookie do core sempre que existir, e
 * — espelhando axiosInstancePriceResearch — fazemos refresh-and-retry em
 * 401/403: sem isso, token expirado vira falha silenciosa e o outbox de
 * sincronização acumula para sempre.
 */
const MyAxiosInstanceAcademy = axios.create({
    baseURL: import.meta.env.VITE_ACADEMY_URL,
})

const cookies = new CookiesService()
let isRefreshing = false
const failedQueue: {
    resolve: (value?: unknown) => void
    reject: (reason?: any) => void
}[] = []

const processQueue = (error: any, token: string | null = null) => {
    failedQueue.forEach((prom) => {
        if (error) {
            prom.reject(error)
        } else {
            prom.resolve(token)
        }
    })
    failedQueue.length = 0
}

MyAxiosInstanceAcademy.interceptors.request.use(
    (config) => {
        const auth = cookies.getAuthData()
        /* Só anexa o header quando há token DE VERDADE. Sem a guarda, quem
           não está autenticado mandava a string literal `Bearer undefined`:
           o servidor não vê "requisição sem token" (que é o que dispara o
           bypass de dev), vê um JWT malformado — e responde 401 "Not enough
           segments". Em produção o resultado é o mesmo 401, só que agora sem
           header lixo no tráfego; em dev é a diferença entre o painel abrir
           com dados e abrir vazio. */
        if (auth?.access_token) {
            config.headers.Authorization = `Bearer ${auth.access_token}`
        }
        return config
    },
    (error) => Promise.reject(error)
)

MyAxiosInstanceAcademy.interceptors.response.use(
    (response) => {
        return response
    },
    async (error) => {
        const prevRequest = error?.config
        if (
            (error?.response?.status === 403 ||
                error?.response?.status === 401) &&
            !prevRequest?.sent
        ) {
            if (isRefreshing) {
                return new Promise(function (resolve, reject) {
                    failedQueue.push({resolve, reject})
                })
            } else {
                prevRequest.sent = true
                try {
                    const auth_api = new AuthApi()
                    isRefreshing = true
                    const {access_token} = await auth_api.doRefreshToken()
                    isRefreshing = false
                    processQueue(null, access_token)
                } catch (error) {
                    processQueue(error, null)
                    console.log('🚀 ~ error:', error)
                    Promise.reject(error)
                }
                return MyAxiosInstanceAcademy(prevRequest)
            }
        }
        return Promise.reject(error)
    }
)

export default MyAxiosInstanceAcademy
